module.exports = __webpack_public_path__ + "static/media/inside-right-seats.06ec69fe.jpg";